
import React, { useEffect, useState } from 'react'
import api from '../../utils/intercepter/axiosConfig';
import { useLocation, useParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const PaiementTrEnregistrement = () => {
    const {state} = useLocation();
    const id_vente= state?.id_vente;

    const {w_id} = useParams();

    const [id_user, setIdUser] = useState(null);

    const [num_tel, setNumTel] = useState(null);
    const [mot_de_passe, setMotDePasse] = useState(null);
    const [montant, setMontant] = useState(6000);

    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    
    const [isSubmitting, setIsSubmiting] = useState(false);

    const navigate = useNavigate();
    
    const fetchTrEnregistrementByWId = async () => {

        try {
          const response = await api.post('/auth/getTrEnregistrOfMutation',{
            w_id: w_id
          });

          if(response.data.status){
            setMontant(response.data.response.montant)
          }
          else{
            console.log("Aucun TF Enregistrement")
          }
        } catch (error) {
          console.log("Erreur Connexion")
        }
      }

      useEffect(() => {
        const token = localStorage.getItem("token");
        if(token){
          const decoded = jwtDecode(token);
          setIdUser(decoded.data.id);
        }
      }, [])

    useEffect(() => {
        if(w_id){
            fetchTrEnregistrementByWId();
        }
    }, [w_id])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmiting(true);
        
        try{

            const response = await api.post("/auth/paiementTrEnregistrement",{
                w_id: w_id,  
                num_tel: num_tel,
                mot_de_passe: mot_de_passe,
                montant: montant,
                id_user: id_user
            })

            if(response.data.status){

              setMessage(response.data.message);
              setMessageType("success");
                
              setNumTel("")
              setMotDePasse("")

              setTimeout(() => navigate(`/vente/details/${id_vente}`,{
                  state: {
                    id_quittance: response.data.response.id,
                    etat_liquidation_id: response.data.response.etat_liquidation_id
                  }
                }), 1000)
                
            }
            else{
                
              setMessage(response.data.message)
              setMessageType("error")

              setNumTel("")
              setMotDePasse("")

            }
        }catch(error){
            if (error.response) {
                const data = error.response.data;
                setMessage(data.message || "Erreur réseau.");
                setMessageType("error");
            } else {
              setMessage("Erreur réseau.");
              setMessageType("error");
            }
        }finally{
          setIsSubmiting(false);
        }
    }

    const retour = () => {
      navigate(-1);
    }

  return (
    <>
    
     <div className='container py-5'>

        <div className='row justify-content-center'>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className='card'>
                  <div className='d-flex justify-content-between align-items-center w-100 px-3 py-1'>
                    <h5 className='card-title mb-0 text-center'>
                      <i className='fa-credit-card'></i>
                      &nbsp;
                      Paiement
                    </h5>
                    <button onClick={retour} className='btn btn-secondary btn-sm mb-0'>
                      Retour
                    </button>
                  </div>
                    <div className='card-body pt-2'>
                        <hr className='my-1'/>

                        {message && (
                <div className={`mt-3 alert ${messageType === "success" ? "alert-success" : "alert-danger"}`}>
                  {message}
                </div>
              )}

                <form onSubmit={handleSubmit}>

            { /** Numéro du téléphone*/}

            <div className="form-group mb-3">
                    <label htmlFor='num_tel'> Numéro du téléphone</label>
                    <input type='text' 
                    className='form-control'
                    id="num_tel"
                    name='num_tel'
                    onChange={(e) => setNumTel(e.target.value)}
                    placeholder="Entrez votre numéro du téléphone"
                    required
                    />
                </div>

            { /** Mot de passe*/}

            <div className="form-group mb-3">
                    <label htmlFor='mot_de_passe'>Mot de passe</label>
                    <input type='password' 
                    className='form-control'
                    id="mot_de_passe"
                    name='mot_de_passe'
                    onChange={(e) => setMotDePasse(e.target.value)}
                    placeholder="Entrez votre mot de passe"
                    required
                    />
                </div>

            { /** Montant non modifiable*/}

            <div className="form-group mb-3">
                    <label htmlFor='montant'>Montant</label>
                    <input type='text' 
                    className='form-control'
                    id="montant"
                    disabled
                    value={montant}
                    name='montant'
                    
                    required
                    />
                </div>

                <div className="row">
                          <div className='col-12'>
                              <button type='submit'  className='btn btn-success w-100' disabled={isSubmitting}>
                                  {isSubmitting ? 'En cours...' : "Effectuer paiement"}
                              </button>
                          </div>
                </div>

            </form>

                    </div>
                </div>
            </div>
        </div>
        
    </div>

    </>
   
    
  )
}

export default PaiementTrEnregistrement

